
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gNdrj", function(module, exports) {
$parcel$export(module.exports, "JiraSmartBanner", function () { return $a6aa00f5612804c5$export$2620a3c848917338; });
/* jira-smart-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $63bv7 = parcelRequire("63bv7");

var $2WL8B = parcelRequire("2WL8B");

var $2gCne = parcelRequire("2gCne");

var $ivETl = parcelRequire("ivETl");

var $lnHkK = parcelRequire("lnHkK");
const $a6aa00f5612804c5$var$STORAGE_KEY = 'SmartBanner_dismiss-jira';
const $a6aa00f5612804c5$var$DISMISS_EXPIRY = 86400;
const $a6aa00f5612804c5$var$IOS_APP_STORE_URL = 'https://apps.apple.com/app/jira-cloud/id1006972087';
const $a6aa00f5612804c5$var$APPLE_APP_ID = '1006972087';
// Android Intent URL with built-in Play Store fallback
const $a6aa00f5612804c5$var$ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.atlassian.android.jira.core';
const $a6aa00f5612804c5$var$ANDROID_INTENT_URL = `intent://home#Intent;scheme=jira;package=com.atlassian.android.jira.core;S.browser_fallback_url=${encodeURIComponent($a6aa00f5612804c5$var$ANDROID_PLAY_STORE_URL)};end`;
const $a6aa00f5612804c5$export$2620a3c848917338 = ({ className: className })=>{
    const { isMobile: isMobile, isAndroid: isAndroid, isMobileSafari: isMobileSafari } = (0, $ivETl.useDeviceInfo)();
    const [isDismissed, setIsDismissed] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const isSoftwareJiraPath = (0, $2WL8B.useIsSoftwareJiraPath)();
    // iOS Safari does not render our custom banner; instead it uses Apple's
    // native Smart App Banner, which is driven by an `apple-itunes-app` meta tag.
    // Only inject it once useIsSoftwareJiraPath confirms the user is on a Jira
    // software path with a Jira instance — the same gate as the custom banner.
    (0, $1oC0p.useEffect)(()=>{
        if (isMobileSafari && isSoftwareJiraPath) {
            const meta = document.createElement('meta');
            meta.name = 'apple-itunes-app';
            meta.content = `app-id=${$a6aa00f5612804c5$var$APPLE_APP_ID}, ct=wac_smart_banner`;
            document.head.appendChild(meta);
            return ()=>{
                if (meta.parentNode) meta.parentNode.removeChild(meta);
            };
        }
    }, [
        isMobileSafari,
        isSoftwareJiraPath
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)($a6aa00f5612804c5$var$STORAGE_KEY, true);
        if (dismissValue !== '1') setIsDismissed(false);
    }, []);
    const handleClose = ()=>{
        setIsDismissed(true);
        (0, $2gCne.setLocalStorage)($a6aa00f5612804c5$var$STORAGE_KEY, '1', $a6aa00f5612804c5$var$DISMISS_EXPIRY);
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartBannerClose',
            eventType: 'ui',
            attributes: {
                productKey: 'jira',
                eventContainer: 'smartBanner'
            }
        }).fire();
    };
    const getDeepLinkUrl = (0, $1oC0p.useCallback)(()=>{
        if (isAndroid) return $a6aa00f5612804c5$var$ANDROID_INTENT_URL;
        return $a6aa00f5612804c5$var$IOS_APP_STORE_URL;
    }, [
        isAndroid
    ]);
    if (!isMobile || isDismissed || isMobileSafari || !isSoftwareJiraPath) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lnHkK.SmartBanner), {
        appIcon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: intl.formatMessage({
            id: 'JiraSmartBanner.title',
            defaultMessage: 'Get the Jira app'
        }),
        subtitle: intl.formatMessage({
            id: 'JiraSmartBanner.subtitle',
            defaultMessage: 'Track tasks, projects, and work'
        }),
        buttonText: intl.formatMessage({
            id: 'JiraSmartBanner.buttonText',
            defaultMessage: 'OPEN'
        }),
        buttonHref: getDeepLinkUrl(),
        buttonAriaLabel: intl.formatMessage({
            id: 'JiraSmartBanner.buttonAriaLabel',
            defaultMessage: 'Open Jira app'
        }),
        onClose: handleClose,
        className: className,
        dataEventProps: {
            'data-product-key': 'jira',
            'data-event-container': 'smartBanner',
            'data-label': 'OPEN',
            'data-label-english': 'OPEN'
        }
    });
};
var $a6aa00f5612804c5$export$2e2bcd8739ae039 = $a6aa00f5612804c5$export$2620a3c848917338;

});

parcelRegister("cB958", function(module, exports) {
$parcel$export(module.exports, "FeaturesDropdown", function () { return $ea82a2d484c53cd9$export$ad0d22100914784b; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");
const $ea82a2d484c53cd9$export$ad0d22100914784b = ()=>{
    const intl = (0, $8e22h.default)();
    const allFeaturesLink = {
        text: intl.formatMessage({
            id: 'jira.FeaturesDropdown.allFeatures',
            defaultMessage: 'All Features'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/features')
    };
    const featureLinks = [
        {
            text: intl.formatMessage({
                id: 'jira.FeaturesDropdown.rovo',
                defaultMessage: 'Rovo in Jira'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/ai')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allFeaturesLink,
                    ...featureLinks
                ]
            }
        ]
    });
};

});

parcelRegister("1jBLM", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return $6235f0ca21d73c59$export$8bb7e16f8f8a7ba6; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $bhzuC = parcelRequire("bhzuC");
const $6235f0ca21d73c59$export$8bb7e16f8f8a7ba6 = ()=>{
    const intl = (0, $8e22h.default)();
    const { data: data } = (0, $bhzuC.useJiraTemplateCategories)();
    const getLocalizedHref = (0, $jQ0cd.useLocalizedHref);
    const allTemplateLink = {
        text: intl.formatMessage({
            id: 'ira.TemplateCategoriesDropdown.allTemplates',
            defaultMessage: 'All templates'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/templates')
    };
    const templateLinks = data.map((category)=>({
            text: category.categoryNameExternal,
            href: getLocalizedHref(`/software/jira/templates/${category.urlSlug}`)
        }));
    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: 'Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates',
            defaultMessage: 'Jira Service Management templates'
        }),
        href: (0, $jQ0cd.useLocalizedHref)('/software/jira/templates/service-management'),
        anchorProps: {
            target: '_blank'
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allTemplateLink,
                    ...templateLinks
                ]
            },
            {
                links: [
                    jsmTemplatesLink
                ]
            }
        ]
    });
};

});
parcelRegister("bhzuC", function(module, exports) {
$parcel$export(module.exports, "useJiraTemplateCategories", function () { return $d5e332dcdb267cf7$export$ef1e726410cc2d37; });

var $1oC0p = parcelRequire("1oC0p");

var $17RBn = parcelRequire("17RBn");

var $kf4PU = parcelRequire("kf4PU");

var $614MQ = parcelRequire("614MQ");
// cache data per locale to optimize duplicate queries
const $d5e332dcdb267cf7$var$cache = new Map();
const $d5e332dcdb267cf7$export$d2adf65b87e47523 = ()=>{
    $d5e332dcdb267cf7$var$cache.clear();
};
const $d5e332dcdb267cf7$export$ef1e726410cc2d37 = ()=>{
    const locale = (0, $17RBn.useLocale)();
    const mappedLocale = (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale];
    // initialize state from cache if available
    const cacheEntry = mappedLocale ? $d5e332dcdb267cf7$var$cache.get(mappedLocale) : undefined;
    const [data, setData] = (0, $1oC0p.useState)(cacheEntry?.data ?? []);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        // if we don't have a mapped locale, do nothing
        if (!mappedLocale) return;
        const existingCache = $d5e332dcdb267cf7$var$cache.get(mappedLocale);
        // if we already have cached data, use it
        if (existingCache?.data && !existingCache.promise) {
            setData(existingCache.data);
            return;
        }
        // if a fetch is already in progress, wait for it
        if (existingCache?.promise) {
            setLoading(true);
            existingCache.promise.then((items)=>{
                setData(items);
                setLoading(false);
            }).catch((err)=>{
                setError(err);
                setLoading(false);
            });
            return;
        }
        // start a new fetch
        setLoading(true);
        setError(null);
        const fetchPromise = (0, $614MQ.getTemplateCategories)({
            // @ts-ignore
            locale: mappedLocale
        }).then((response)=>{
            const items = response.taxonomyTemplateCategoryCollection.items ?? [];
            // update cache with data and clear promise
            $d5e332dcdb267cf7$var$cache.set(mappedLocale, {
                data: items,
                promise: null
            });
            setData(items);
            setLoading(false);
            return items;
        }).catch((err)=>{
            // clear promise on error
            const entry = $d5e332dcdb267cf7$var$cache.get(mappedLocale);
            if (entry) entry.promise = null;
            setError(err);
            setLoading(false);
            throw err;
        });
        // store the in-flight promise
        $d5e332dcdb267cf7$var$cache.set(mappedLocale, {
            data: existingCache?.data ?? [],
            promise: fetchPromise
        });
    }, [
        locale,
        mappedLocale
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});
parcelRegister("614MQ", function(module, exports) {
$parcel$export(module.exports, "getTemplateCategories", function () { return $8003fdfd77cf038c$export$819167f3de5f32cb; });

var $kXfPT = parcelRequire("kXfPT");

var $eRzlV = parcelRequire("eRzlV");
const $8003fdfd77cf038c$var$JIRA_PRODUCT_INTERNAL_TITLE = 'Jira Cloud Product';
const $8003fdfd77cf038c$export$52bf0b65d881440d = (0, $kXfPT.gql)`
query ($locale: String) {
  taxonomyTemplateCategoryCollection(
    locale: $locale
    limit: 100,
    where: {
      product: {
        internalTitle: "${$8003fdfd77cf038c$var$JIRA_PRODUCT_INTERNAL_TITLE}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`;
const $8003fdfd77cf038c$export$819167f3de5f32cb = (args)=>{
    const { locale: locale } = args;
    return (0, $kXfPT.request)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        document: $8003fdfd77cf038c$export$52bf0b65d881440d,
        variables: {
            locale: locale
        },
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};

});
parcelRegister("kXfPT", function(module, exports) {
$parcel$export(module.exports, "request", function () { return $f4159a034cc4c190$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "gql", function () { return $f4159a034cc4c190$export$72e4926bf8358653; });

var $eLb04 = parcelRequire("eLb04");

var $haH5f = parcelRequire("haH5f");

var $fSIns = parcelRequire("fSIns");

var $Xz7Q6 = parcelRequire("Xz7Q6");

var $1iZL3 = parcelRequire("1iZL3");

var $6FOC8 = parcelRequire("6FOC8");

var $fuprL = parcelRequire("fuprL");
/**
 * Convert the given headers configuration into a plain object.
 */ const $f4159a034cc4c190$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $6FOC8 && $6FOC8.Headers && headers instanceof $6FOC8.Headers) oHeaders = (0, $haH5f.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $f4159a034cc4c190$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $f4159a034cc4c190$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($f4159a034cc4c190$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $f4159a034cc4c190$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $f4159a034cc4c190$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $f4159a034cc4c190$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $f4159a034cc4c190$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? (0, $eLb04.defaultJsonSerializer)
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $f4159a034cc4c190$export$b0f268a6eae2cdf1 {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $fSIns.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(rawRequestOptions.query);
            return $f4159a034cc4c190$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)),
                    ...$f4159a034cc4c190$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $fSIns.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(requestOptions.document);
        return $f4159a034cc4c190$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)),
                ...$f4159a034cc4c190$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $fSIns.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $Xz7Q6.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $f4159a034cc4c190$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)),
                ...$f4159a034cc4c190$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))),
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
const $f4159a034cc4c190$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $f4159a034cc4c190$var$createHttpMethodFetcher((0, $haH5f.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $f4159a034cc4c190$var$getResult(response, fetchOptions.jsonSerializer ?? (0, $eLb04.defaultJsonSerializer));
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new (0, $1iZL3.ClientError)(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $f4159a034cc4c190$export$3052fa16c23a17ef = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $fSIns.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
// prettier-ignore
// eslint-disable-next-line
async function $f4159a034cc4c190$export$b5fe3f66a567bec0(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $fSIns.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $f4159a034cc4c190$export$72420c3222c11ca1 = async (...args)=>{
    const params = $f4159a034cc4c190$var$parseBatchRequestsArgsExtended(args);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(params.url);
    return client.batchRequests(params);
};
const $f4159a034cc4c190$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $f4159a034cc4c190$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? (0, $eLb04.defaultJsonSerializer);
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $f4159a034cc4c190$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $f4159a034cc4c190$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
const $f4159a034cc4c190$export$72e4926bf8358653 = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
var $f4159a034cc4c190$export$2e2bcd8739ae039 = $f4159a034cc4c190$export$b5fe3f66a567bec0;

});
parcelRegister("eLb04", function(module, exports) {
$parcel$export(module.exports, "defaultJsonSerializer", function () { return $abedfcdcad7ec23a$export$94978876ea00418f; });
const $abedfcdcad7ec23a$export$94978876ea00418f = JSON;

});

parcelRegister("haH5f", function(module, exports) {
$parcel$export(module.exports, "uppercase", function () { return $c804ca5df265e067$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "HeadersInstanceToPlainObject", function () { return $c804ca5df265e067$export$8cbbf7c85c69d7bd; });
const $c804ca5df265e067$export$6cfe151e6b925e83 = (str)=>str.toUpperCase();
const $c804ca5df265e067$export$8cbbf7c85c69d7bd = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};

});

parcelRegister("fSIns", function(module, exports) {
$parcel$export(module.exports, "parseRequestArgs", function () { return $02fbd80aa1deaafb$export$23fbebc38045fef1; });
$parcel$export(module.exports, "parseRawRequestArgs", function () { return $02fbd80aa1deaafb$export$915c311301d24138; });
$parcel$export(module.exports, "parseBatchRequestArgs", function () { return $02fbd80aa1deaafb$export$db48f1a2d994371; });
$parcel$export(module.exports, "parseRequestExtendedArgs", function () { return $02fbd80aa1deaafb$export$77a1c1c6dd0fc83d; });
$parcel$export(module.exports, "parseRawRequestExtendedArgs", function () { return $02fbd80aa1deaafb$export$7dbb6e4001743509; });
const $02fbd80aa1deaafb$export$23fbebc38045fef1 = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$915c311301d24138 = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$db48f1a2d994371 = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$77a1c1c6dd0fc83d = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$7dbb6e4001743509 = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};

});

parcelRegister("Xz7Q6", function(module, exports) {
$parcel$export(module.exports, "resolveRequestDocument", function () { return $0b30c1fbc38efde2$export$8a71244cbc138170; });

var $bUPIt = parcelRequire("bUPIt");
var $hj3p7 = parcelRequire("hj3p7");
/**
 * helpers
 */ const $0b30c1fbc38efde2$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $0b30c1fbc38efde2$export$8a71244cbc138170 = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $bUPIt.parse)(document);
            operationName = $0b30c1fbc38efde2$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $0b30c1fbc38efde2$var$extractOperationName(document);
    return {
        query: (0, $hj3p7.print)(document),
        operationName: operationName
    };
};

});

parcelRegister("1iZL3", function(module, exports) {
$parcel$export(module.exports, "ClientError", function () { return $0f3760bf22470851$export$bb8c263ad32caa8; });
class $0f3760bf22470851$export$bb8c263ad32caa8 extends Error {
    constructor(response, request){
        const message = `${$0f3760bf22470851$export$bb8c263ad32caa8.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $0f3760bf22470851$export$bb8c263ad32caa8.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $0f3760bf22470851$export$bb8c263ad32caa8);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}

});

parcelRegister("6FOC8", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("fuprL", function(module, exports) {
/* eslint-disable */ 
var $Xz7Q6 = parcelRequire("Xz7Q6");

var $1iZL3 = parcelRequire("1iZL3");
// import type WebSocket from 'ws'
const $b46d659564fbec9f$var$CONNECTION_INIT = `connection_init`;
const $b46d659564fbec9f$var$CONNECTION_ACK = `connection_ack`;
const $b46d659564fbec9f$var$PING = `ping`;
const $b46d659564fbec9f$var$PONG = `pong`;
const $b46d659564fbec9f$var$SUBSCRIBE = `subscribe`;
const $b46d659564fbec9f$var$NEXT = `next`;
const $b46d659564fbec9f$var$ERROR = `error`;
const $b46d659564fbec9f$var$COMPLETE = `complete`;
class $b46d659564fbec9f$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b46d659564fbec9f$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $b46d659564fbec9f$export$5eb90cb6288c26cf {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b46d659564fbec9f$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b46d659564fbec9f$var$parseMessage(e.data);
                switch(message.type){
                    case $b46d659564fbec9f$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b46d659564fbec9f$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b46d659564fbec9f$var$Pong(r).text));
                        else socket.send($b46d659564fbec9f$var$Pong(null).text);
                        return;
                    case $b46d659564fbec9f$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b46d659564fbec9f$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new (0, $1iZL3.ClientError)({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b46d659564fbec9f$var$ERROR:
                        subscriber.error && subscriber.error(new (0, $1iZL3.ClientError)({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b46d659564fbec9f$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b46d659564fbec9f$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b46d659564fbec9f$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b46d659564fbec9f$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$b46d659564fbec9f$export$5eb90cb6288c26cf.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function $b46d659564fbec9f$var$parseMessage(data, f = (a)=>a) {
    const m = $b46d659564fbec9f$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b46d659564fbec9f$var$ConnectionInit(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$CONNECTION_INIT, payload);
}
function $b46d659564fbec9f$var$Ping(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$PING, payload, undefined);
}
function $b46d659564fbec9f$var$Pong(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$PONG, payload, undefined);
}
function $b46d659564fbec9f$var$Subscribe(id, payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$SUBSCRIBE, payload, id);
}
function $b46d659564fbec9f$var$Complete(id) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$COMPLETE, undefined, id);
}

});





parcelRegister("8IN8s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f81b8289a3c24944$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $gNdrj = parcelRequire("gNdrj");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $9KOR3 = parcelRequire("9KOR3");

var $iOXki = parcelRequire("iOXki");

var $cB958 = parcelRequire("cB958");

var $1jBLM = parcelRequire("1jBLM");
const $f81b8289a3c24944$var$JiraLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useDarkTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $f81b8289a3c24944$var$JiraSoftwareNav = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const intl = (0, $8e22h.default)();
    const ctaText = intl.formatMessage({
        id: 'JiraFeatureSoftwarePageTemplate.navbar.getItFree',
        defaultMessage: 'Get it free'
    });
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0,
            transform: 'translateX(-40%)'
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/marketing');
    const engineeringHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/engineering');
    const designHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/design');
    const operationsHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/operations');
    const itHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/it');
    // Use Cases Hrefs
    const gettingStartedHref = (0, $jQ0cd.useLocalizedHref)('https://community.atlassian.com/learning/hub/jira');
    const planningHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/planning');
    const campaignManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/campaign-management');
    const agileProjectManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/agile-project-management');
    const programManagementHref = (0, $jQ0cd.useLocalizedHref)('/jira/solutions/program-management');
    //Company Size Hrefs
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/enterprise');
    const solutionsDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.teams.header',
                        defaultMessage: 'Teams'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.marketing',
                                defaultMessage: 'Marketing'
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.engineering',
                                defaultMessage: 'Engineering'
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.design',
                                defaultMessage: 'Design'
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.operations',
                                defaultMessage: 'Operations'
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.teams.it',
                                defaultMessage: 'IT'
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.useCases.header',
                        defaultMessage: 'Use Cases'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.getting-started',
                                defaultMessage: 'Getting started'
                            }),
                            href: gettingStartedHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.planning',
                                defaultMessage: 'Planning'
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.campaign-management',
                                defaultMessage: 'Campaign Management'
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.agile-project-management',
                                defaultMessage: 'Agile Project Management'
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.useCases.program-management',
                                defaultMessage: 'Program Management'
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: 'software-jira.navbar.solutions.companySize.header',
                        defaultMessage: 'Company Size'
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: 'software-jira.navbar.solutions.companySize.enterprise',
                                defaultMessage: 'Enterprise'
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        gettingStartedHref,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/guides/getting-started/introduction');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/pricing');
    const productLogoHref = (0, $jQ0cd.useLocalizedHref)('/software/jira');
    const templatesLinkContent = (0, $1oC0p.useMemo)(()=>{
        return {
            globalLinksKey: 'templates',
            linkText: intl.formatMessage({
                id: 'software-jira.navbar.templates',
                defaultMessage: 'Templates'
            }),
            productKey: 'jira',
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jBLM.TemplateCategoriesDropdown), {}),
            dropdownType: 'templates',
            containerPosition: 'relative'
        };
    }, [
        intl
    ]);
    const featuresLinkContent = (0, $1oC0p.useMemo)(()=>({
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                id: 'software-jira.navbar.features',
                defaultMessage: 'Features'
            }),
            productKey: 'jira',
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cB958.FeaturesDropdown), {}),
            dropdownType: 'features',
            containerPosition: 'relative'
        }), [
        intl
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasSubnav: true,
                productKey: 'jira',
                containerPosition: 'relative',
                containerStyles: solutionsDropdownStyles,
                dropdownType: 'solutions',
                content: solutionsDropdown
            },
            {
                globalLinksKey: 'guides',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.guides',
                    defaultMessage: 'Guides'
                }),
                hasSubnav: false,
                productKey: 'jira',
                href: guidesHref
            },
            templatesLinkContent,
            {
                globalLinksKey: 'pricing',
                linkText: intl.formatMessage({
                    id: 'software-jira.navbar.pricing',
                    defaultMessage: 'Pricing'
                }),
                hasSubnav: false,
                productKey: 'jira',
                href: pricingHref
            }
        ], [
        intl,
        featuresLinkContent,
        templatesLinkContent,
        solutionsDropdown,
        solutionsDropdownStyles,
        guidesHref,
        pricingHref
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNdrj.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
                globalNavItemKeys: globalNavItemKeys,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
                    productLogoUrl: productLogoHref,
                    productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($f81b8289a3c24944$var$JiraLogo, {}),
                    productLogoAriaLabel: intl.formatMessage({
                        id: 'wacJiraSoftwareNavigation.logo-label',
                        defaultMessage: 'Jira Software logo'
                    }),
                    mobileCtaText: intl.formatMessage({
                        id: 'JiraeSoftwarePageTemplate.navbar.getitfree',
                        defaultMessage: 'Get it free'
                    }),
                    mobileCtaUrl: signupLink,
                    mobileCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($f81b8289a3c24944$var$JiraLogo, {}),
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: signupLink,
                    navigationTrynowCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    productPageNavLinks: links,
                    mobileLinksSections: [
                        {
                            mobileLinkKey: 'mobile-jira',
                            mobileLinksProps: links
                        }
                    ],
                    additionalMenuPageObjectsArray: [
                        {
                            menuPageKey: 'features',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'features')?.content
                        },
                        {
                            menuPageKey: 'solutions',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'solutions')?.content
                        },
                        {
                            menuPageKey: 'templates',
                            menuPageObjects: links.find((link)=>link.globalLinksKey === 'templates')?.content
                        }
                    ]
                })
            })
        ]
    });
};
$f81b8289a3c24944$var$JiraSoftwareNav.displayName = 'JiraSoftwareNav';
var $f81b8289a3c24944$export$2e2bcd8739ae039 = $f81b8289a3c24944$var$JiraSoftwareNav;

});


//# sourceMappingURL=confluence-software-anchor-lp-automation.3efa33f4.js.map
